import React, { useState, useEffect } from 'react';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
//import 'youtube-background';

import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import WelcomeBanner from '../partials/dashboard/WelcomeBanner';
import DashboardAvatars from '../partials/dashboard/DashboardAvatars';
import FilterButton from '../partials/actions/FilterButton';
import Datepicker from '../partials/actions/Datepicker';
import AlertModal from '../partials/AlertModal'
import PaginationNumeric from '../components/PaginationNumeric'

import CallToActionDetail from "../partials/ctas/CallToActionDetail";
import CallToActionCards from '../partials/ctas/CallToActionCards'
import LiveCampaignsContent from '../partials/dashboard/live-campaigns/LiveCampaignsContent'
import OptimalShedulingContent from '../partials/dashboard/optimal-scheduling/OptimalSchedulingContent'
import TrendingContent from '../partials/dashboard/trending-content/TrendingContent'

import { Auth, API, graphqlOperation } from 'aws-amplify';
import { getClientUser } from '../graphql/queries'
import { createClient, createClientUser, deleteClient, updateClient } from '../graphql/mutations'
import { Storage } from 'aws-amplify';

import DashboardHeatmapCard from '../partials/dashboard/DashboardHeatmapCard'
import DashboardCategoryCard from '../partials/dashboard/DashboardCategoryCard'
import DashboardCloudCard from '../partials/dashboard/DashboardCloudCard'
import CTAModal from "../partials/CTAModal";


function CallToActions() {

  let history = useHistory();
  const location = useLocation()
  const search = location.search;
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [authSession, setAuthSession] = useState(null)
  const [alertModalState, setAlertModalState] = useState(null)
  const [contentState, setContentState] = useState(null)
  const [emulatorData, setEmulatorData] = useState({})
  const [ authToken, setAuthToken ] = useState(null)
  const [ctaModalState, setCTAModalState] = useState(null)

  const [userDetails, setUserDetails] = useState({email: 'friend', client: { adminId: ''}})

  useEffect(() => {
    OnLoad();
  }, []);

  function updateContentState(newState){
    setContentState(newState)
  }

  function OnLoad() {

    Auth.currentSession().then(response => {
      if(location!=null) {
        if(location.state==null) {
          history.push('/signin')
        }
        else{
          setUserDetails(location.state.userDetails)
        }
      }
      else {
        history.push('/signin')
      }
      setAuthSession(response)
      userHasAuthenticated(true);
      setIsAuthenticating(false);

    }).catch( (error) => {
      history.push('/signin')
    });
  }

  return !isAuthenticating && (
      <div className="flex h-screen overflow-hidden striped-background-pattern">
        {/* Page Title */}
        <Helmet>
          <title>EmPushy | Call-to-actions</title>
        </Helmet>

        {/* Sidebar */}
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>

        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">

          {/*  Site header */}
          <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} userDetails={userDetails}/>


          <main>

            {
              contentState===null?
              <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">

                {/* Page header */}
                <div className="sm:flex sm:justify-between sm:items-center mb-5">

                  {/* Left: Title */}
                  <div className="mb-4 sm:mb-0">
                    <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">We ❤️ campaigns with clear and
                      concise <i>Intents</i></h1>
                    <p className="mb-6 text-justify">...and so do your subscribers! Technology users are bombarded with hundreds and
                      thousands of campaigns every week 🙈 If the intent of your campaign is not clear and easy to understand, your
                    subscribers will dismiss it and move on 🏃‍ Check out the examples below which demonstrate a wide variety of good
                    (and bad!) call-to-action campaigns 🔔</p>
                  </div>

                  {/* Right: Actions */}
                  <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">

                    {/* Add meetup button */}
                    {/*<button className="btn bg-indigo-500 hover:bg-indigo-600 text-white">
                      <svg className="w-4 h-4 fill-current opacity-50 shrink-0" viewBox="0 0 16 16">
                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                      </svg>
                      <span className="hidden xs:block ml-2">Feedback</span>
                    </button>*/}

                  </div>

                </div>

                {/* Content */}
                <CallToActionCards updateContentState={updateContentState}/>


              </div>:<CallToActionDetail updateContentState={updateContentState} setAlertModalState={setAlertModalState}
                                      authToken={authSession.idToken.jwtToken} cta={contentState} setModalState={setCTAModalState}/>
            }



            <AlertModal params={alertModalState} toggleState={setAlertModalState}/>
            <CTAModal params={ctaModalState} toggleState={setCTAModalState}/>

          </main>
        </div>
      </div>
  );
}

export default CallToActions;